import { GridValueGetterParams } from '@mui/x-data-grid-pro';
import { DocumentRequestStatusForCandidateListLabel } from '../../../../common/request/ui/document-request-status';
import { DocumentRequestStatusEnum } from '../../../../common/request/enums/document-request-status.enum';

export const documentStatusGetter = (
  params: GridValueGetterParams<any, any>
) => {
  return (
    DocumentRequestStatusForCandidateListLabel[
      params.row.documentStatus as DocumentRequestStatusEnum
    ] ||
    DocumentRequestStatusForCandidateListLabel[
      params.row.documentRequestStatus as DocumentRequestStatusEnum
    ] ||
    '-'
  );
};
